// extracted by mini-css-extract-plugin
export default {"form":"GadgetModal_form__rsdBB","slug":"GadgetModal_slug__NGchN","fullWidth":"GadgetModal_fullWidth__KcjBA"};